import React from 'react';
import { withTranslation } from 'react-i18next';
import Header from 'components/Layout/Header';

class NotFound extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Header />
        <div className="notfound page-notfound">
          <div className="container-fluid">
            <h1>404</h1>
            <h3>:(</h3>
            <h2>{t('notFound.message')}</h2>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(NotFound);
